import { ContentfulTakeoverBlock, ContentfulCarouselType } from '@jbhi-fi/apis/src/contentful/types';
import { TakeoverBlockProps } from '../../TakeoverBlock/TakeoverBlock';
import { CarouselBannerTransformer } from './CarouselBannerTransformer';
import { CarouselTransformer, ToProductCarouselBaseOptions } from './CarouselTransformer/CarouselTransformer';
import { ThemeTransformer } from './ThemeTransformer';

export abstract class TakeoverBlockTransformer {
  static toTakeoverBlockProps = (
    entry: ContentfulTakeoverBlock,
    { isLoggedIn, productTrackingData }: ToProductCarouselBaseOptions & { isLoggedIn?: boolean } = {}
  ): TakeoverBlockProps => {
    const carousel =
      entry?.fields?.carousel.fields?.type === ContentfulCarouselType.PromoCard
        ? CarouselTransformer.toListingBlockPromoCardCarouselProps(entry?.fields.carousel, {
            isLoggedIn: isLoggedIn,
          })
        : entry.fields?.carousel
          ? CarouselTransformer.toListingBlockProductCarouselProps(entry.fields?.carousel, { productTrackingData })
          : undefined;

    const theme = ThemeTransformer.toContentThemePalette(entry?.fields?.heroBanner?.fields?.backgroundColour);

    return {
      backgroundColor: theme.background,
      headingColor: theme.heading,
      heroBanner: CarouselBannerTransformer.toHeroBannerProps(entry?.fields?.heroBanner),
      heading: entry.fields?.displayCarouselHeading ? carousel?.heading : undefined,
      carousel: carousel?.children ?? null,
    } as TakeoverBlockProps;
  };
}
